import { Row } from "@/components/Row";
import { Button } from "@/components/ui/button";

import { cn } from "@/lib/utils";
import { GoalPeriod } from "@/types";

// Compact segmented pill toggle between week and month, shared by the
// dashboard stat cards.
export const DashboardPeriodToggle = ({
  isAbbreviated = false,
  period,
  onPeriodChange,
}: {
  isAbbreviated?: boolean;
  period: GoalPeriod;
  onPeriodChange: (period: GoalPeriod) => void;
}) => {
  const options: { value: GoalPeriod; label: string }[] = [
    { value: GoalPeriod.WEEK, label: isAbbreviated ? "W" : "Week" },
    { value: GoalPeriod.MONTH, label: isAbbreviated ? "M" : "Month" },
  ];

  return (
    <Row className="items-center gap-0.5 rounded-full bg-lever-surface-neutral p-0.5">
      {options.map(({ value, label }) => {
        const isActive = period === value;
        return (
          <Button
            key={value}
            type="button"
            variant="ghost"
            size="sm"
            className={cn(
              "h-4 rounded-full px-1.5 py-0 text-[10px] font-medium hover:bg-transparent",
              isActive
                ? "bg-lever-surface-default text-lever-text-heading shadow-sm hover:bg-lever-surface-default"
                : "text-lever-text-label hover:text-lever-text-body",
            )}
            onClick={() => {
              onPeriodChange(value);
            }}
          >
            {label}
          </Button>
        );
      })}
    </Row>
  );
};
